import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

let _accessToken = null;
let _sessionId = null;
let _onUnauthorized = null;

export function setAccessToken(token) {
  _accessToken = token;
}
export function getAccessToken() {
  return _accessToken;
}
export function setSessionId(sid) {
  _sessionId = sid;
}
export function getSessionId() {
  return _sessionId;
}
export function onUnauthorized(cb) {
  _onUnauthorized = cb;
}

api.interceptors.request.use((cfg) => {
  if (_accessToken) {
    cfg.headers.Authorization = `Bearer ${_accessToken}`;
  }
  if (_sessionId) {
    cfg.headers["X-Session-Id"] = _sessionId;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    if (status === 401 && _onUnauthorized) {
      _onUnauthorized();
    }
    return Promise.reject(err);
  }
);

export default api;
